// extracted by mini-css-extract-plugin
export default {"payment":"kz","title_row":"lz","border_bottom":"mz","promo_wrapper":"nz","payment_wrapper":"oz","label":"pz","card_row":"qz","cardcontain":"rz","card_input":"sz","card_error":"tz","card_label":"uz","lock":"vz","same_address":"wz","place_order_button":"xz","buttonwrap":"yz","hide_form":"zz","paypal_buttons":"Az","review_button":"Bz","alt_payment":"Cz"};
    if(module.hot) {
      // 1714422956045
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  